import { DisclosureContent, type DisclosureStore } from '@ariakit/react';
import { createColumnHelper } from '@tanstack/react-table';
import { ConfigOverrideValue } from '#components/patterns/config-overrides/ConfigOverrideValue.tsx';
import { CONFIG_OVERRIDE_LABELS } from '#components/patterns/config-overrides/labels/ConfigOverrideLabels.ts';
import { Table } from '#components/patterns/table/Table.tsx';
import type { ConfigOverride } from '#dn-types/host.ts';
import styles from './StatsDisclosureContent.module.css';

type Item = ConfigOverride;

type Props = {
  configOverrides: Item[];
  disclosure: DisclosureStore;
};

const columnHelper = createColumnHelper<Item>();

const columns = [
  columnHelper.accessor('key', {
    header: '',
    cell(info) {
      return <>{CONFIG_OVERRIDE_LABELS[info.getValue()]}</>;
    },
  }),
  columnHelper.accessor('value', {
    header: '',
    size: 200,
    cell(info) {
      const configOverride = info.row.original;
      return <ConfigOverrideValue configOverride={configOverride} usePills={true} />;
    },
  }),
  columnHelper.display({
    id: 'dummy-column',
    header: '',
    size: 34,
  }),
];

export function StatsDisclosureContent({ configOverrides, disclosure }: Props) {
  const statsConfigOverrides = configOverrides.filter(({ key }) => key.startsWith('stats.') && key !== 'stats.type');

  return (
    <DisclosureContent store={disclosure}>
      <Table data={statsConfigOverrides} columns={columns} className={styles.StatsDisclosureContent_table} />
    </DisclosureContent>
  );
}
